import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { formName } from '../Constants/constants';
import { confirmForm, editForm, BASIC_COVERAGE_FORM } from '../Actions/actions';
import BasicCoverage from '../Components/BasicCoverage/BasicCoverage';

const formValues = formValueSelector(formName);

const mapStateToProps = (state) => ({
  options: state.formPage.basicCoverage.options,
  enabled: state.formPage.basicCoverage.enabled,
  confirmed: state.formPage.basicCoverage.confirmed,
  valid: state.formPage.basicCoverage.valid,
  value:
    formValues(state, 'generalLiabilityCoverage').toString() ||
    state.formPage.basicCoverage.options[0],
  ACSellingLiquor: formValues(state, 'ACSellingLiquor'),
});

const mapDispatchToProps = (dispatch) => ({
  edit: () => dispatch(editForm(BASIC_COVERAGE_FORM)),
  confirm: () => dispatch(confirmForm(BASIC_COVERAGE_FORM)),
});

const BasicCoverageContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BasicCoverage);

export default BasicCoverageContainer;
